import React, {useState} from 'react';

import {hooks} from '../hooks';
import {Routes} from '../routes';
import {svg} from '../assets/svg';
import {AcademyType} from '../types';
import {components} from '../components';
import {actions} from '../store/actions';

export const DetailAcademy: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const academy: AcademyType = location.state.academy;

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
        title='Academy'
      />
    );
  };

  const renderImage = (): JSX.Element => {
    if (!academy.img) return <></>;
    return (
      <section style={{position: 'relative', marginBottom: 30}}>
        <img
          src={academy.img}
          alt={academy.name}
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </section>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section className='container' style={{paddingTop: 10, paddingBottom: 20}}>
        <h3
          className='number-of-lines-1'
          style={{textTransform: 'capitalize', marginBottom: 10}}
        >
          {academy.name}
        </h3>
        <p className='t12'>{academy.description}</p>
        <br />

        {/* <div className='row-center-space-between'>
          <h5>Buku Bahasa Indonesia</h5>
          <span className='clickable row-center-space-between'><svg.PdfSvg /> <span className='t12' style={{marginLeft: 5}}>Download</span></span>
        </div> */}
        <ul>
          {academy.books?.map((books, index) => (
              <li
                key={books.id}
                className={index % 2 === 0 ? 'bg-white' : 'bg-green-secondary'}
                style={{
                  padding: 10,
                  borderRadius: 6,
                  marginBottom: 10
                }}
              >
                <div className='row-center-space-between' style={{marginBottom: 5}}>
                  <h5>{books.title}</h5>
                  <span className='clickable row-center-space-between' onClick={() => window.open(books.file, '_blank')}><svg.PdfSvg /> <span className='t12' style={{marginLeft: 5}}>Download</span></span>
                </div>
                <p className='t10'>{books.author}</p>
                <p className='t10'>{books.publisher} - {books.year}</p>
              </li>
          ))}
        </ul>
      </section>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable'>
        {renderImage()}
        {renderDetails()}
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
